import { render, staticRenderFns } from "./BlackTwoPrize.vue?vue&type=template&id=0cdef1c8&scoped=true&"
import script from "./BlackTwoPrize.vue?vue&type=script&lang=js&"
export * from "./BlackTwoPrize.vue?vue&type=script&lang=js&"
import style0 from "./BlackTwoPrize.vue?vue&type=style&index=0&id=0cdef1c8&prod&lang=less&scoped=true&"
import style1 from "./BlackTwoPrize.vue?vue&type=style&index=1&id=0cdef1c8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdef1c8",
  null
  
)

export default component.exports